import { render, staticRenderFns } from "./PositionListInvoice.vue?vue&type=template&id=37884b92&scoped=true&lang=pug&"
import script from "./PositionListInvoice.vue?vue&type=script&lang=ts&"
export * from "./PositionListInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./PositionListInvoice.vue?vue&type=style&index=0&id=37884b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37884b92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VEditDialog,VIcon,VTooltip})
